import { ApiUser } from 'api/types/ApiUserEnvironment';
import { getItem } from 'utils/localStorage';

export const isStaff = (user: ApiUser | null) =>
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  user && user.permissions.includes('staff');

export const isNonAdmin = (user: ApiUser | null) =>
  Boolean(
    user &&
      !user.permissions.includes('staff') &&
      !user.permissions.includes('orgAdmin')
  );

export const isLocationInCountry = (
  user: ApiUser | null,
  countryCode: string
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
) => user && user.location && user.location.countryCode === countryCode;

export const isSalarySurveyCompleted = (user: ApiUser | null) => {
  if (user) {
    return Boolean(user.salarySurvey.lastSubmitted);
  }

  return Boolean(getItem('salarySurveyLastSubmitted'));
};

export const salarySurveyLastSubmittedDate = (user: ApiUser | null) => {
  if (user) {
    return user.salarySurvey.lastSubmitted;
  }

  const localStorageLastSubmitted = getItem('salarySurveyLastSubmitted');

  if (Array.isArray(localStorageLastSubmitted)) {
    return localStorageLastSubmitted[0];
  }

  return null;
};
